"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _ToastContainer = _interopRequireDefault(require("./ToastContainer"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var existedNotification = {};

var createNotification = function createNotification(properties) {
  return new Promise(function (resolve) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    var called = false;

    function ref(element, _ref) {
      var add = _ref.add,
          remove = _ref.remove;

      if (called) {
        return;
      }

      called = true;
      resolve({
        add: add,
        remove: remove,
        element: element,
        destroy: function destroy() {
          _reactDom["default"].unmountComponentAtNode(div);

          if (div.parentNode) {
            div.parentNode.removeChild(div);
          }
        },
        update: function update(updates) {
          /**
           * For updating theme (switch between light and dark)
           */
          _reactDom["default"].render((0, _jsxRuntime.jsx)(_ToastContainer["default"], _objectSpread(_objectSpread({}, updates), {}, {
            ref: ref
          })), div);
        }
      });
    } // We need to render toasts outside of the root div to put all toasts from app together
    // and keep showing toasts when navigating between screens


    _reactDom["default"].render((0, _jsxRuntime.jsx)(_ToastContainer["default"], _objectSpread(_objectSpread({}, properties), {}, {
      ref: ref
    })), div);
  });
};

var toast = function () {
  // Add or update a toast
  var notify = function notify(props) {
    if (existedNotification.add) {
      // Only create one container to provide layout animation for toasts
      // If it exists, use the methods from existed one
      existedNotification.add(props);
      return;
    }

    createNotification().then(function (response) {
      existedNotification = _objectSpread({}, response);
      existedNotification.add(props);
    });
  }; // Update ToastContainer config


  var globalConfig = function globalConfig(updates) {
    if (existedNotification.update) {
      existedNotification.update(updates);
    } else {
      createNotification(updates).then(function (response) {
        existedNotification = _objectSpread({}, response);
      });
    }
  }; // Remove a toast with a key
  // the key must be passed first throught notify method


  var remove = function remove(key) {
    if (existedNotification.remove) {
      existedNotification.remove(key);
    }
  };

  return {
    notify: notify,
    remove: remove,
    globalConfig: globalConfig
  };
}();

var _default = toast;
exports["default"] = _default;
//# sourceMappingURL=index.js.map